import { useEffect } from 'react';

export const CATALOG_REFRESH_EVENT = 'endchess:catalog-refresh';

export type CatalogRefreshDetail = {
  courses: boolean;
  games: boolean;
};

export function notifyCatalogRefresh(detail: CatalogRefreshDetail): void {
  window.dispatchEvent(
    new CustomEvent<CatalogRefreshDetail>(CATALOG_REFRESH_EVENT, { detail }),
  );
}

export function useCatalogRefresh(
  handler: (detail: CatalogRefreshDetail) => void,
): void {
  useEffect(() => {
    const listener = (event: Event) => {
      handler((event as CustomEvent<CatalogRefreshDetail>).detail);
    };

    window.addEventListener(CATALOG_REFRESH_EVENT, listener);
    return () => window.removeEventListener(CATALOG_REFRESH_EVENT, listener);
  }, [handler]);
}
